export default (newPaymentFormData) => ({
  name: newPaymentFormData?.bankName,
  country: newPaymentFormData?.bankCountry,
  bic: newPaymentFormData?.bic
});
